import { useMemo } from 'react';
import { BoardingPlacePreview } from '../Types/reservationTypes';
import { ReservationSelectedBookingContext } from '../Types/reservationBookingContext.types';

/**
 * Custom hook to retrieve local prices for a reservation, including unit price and boarding place price.
 *
 * @param selectedBookingContext - Booking context hydrated by selected booking ID.
 * @param offerBoardingPlaces - Optional array of boarding place previews.
 * @param offerBoardingPlaceId - Optional boarding place identifier to find the corresponding boarding place price.
 * @returns An object containing `localUnitPrice` and `localBoardingPlacePrice`.
 */
export const useReservationLocalPrices = ({
  selectedBookingContext,
  offerBoardingPlaces,
  offerBoardingPlaceId,
}: {
  selectedBookingContext?: ReservationSelectedBookingContext;
  offerBoardingPlaces?: BoardingPlacePreview[];
  offerBoardingPlaceId?: number | null;
}) => {
  const localUnitPrice = useMemo(
    () => selectedBookingContext?.price,
    [selectedBookingContext?.price]
  );

  const localBoardingPlacePrice = useMemo(() => {
    if (!offerBoardingPlaces || !offerBoardingPlaceId) return undefined;
    return offerBoardingPlaces.find((bp) => bp.id === offerBoardingPlaceId)?.price;
  }, [offerBoardingPlaces, offerBoardingPlaceId]);

  return { localUnitPrice, localBoardingPlacePrice };
};
